<template>
  <div class="login-shell">
    <v-snackbar v-model="showSnackBar" color="#ff6907" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span class="snackbar-text">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #fff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <div class="login-overlay"></div>

    <div class="login-content">
      <div class="login-card-wrap">
        <div class="login-card">
          <div class="login-brand">
            <div class="login-brand__orb"></div>
            <div class="login-brand__inner">
              <div class="login-brand__logos">
                <div class="login-brand__logo-box">
                  <img :src="sarpaLogo" alt="Sarpa logo" class="login-brand__logo">
                </div>
                <div class="login-brand__logo-box login-brand__logo-box--wide">
                  <img :src="wildwatchLogo" alt="WildWatch logo" class="login-brand__logo login-brand__logo--wildwatch">
                </div>
              </div>

              <h1 class="login-brand__title">HUMAN WILDLIFE CONFLICT PORTAL</h1>
              <div class="login-brand__subtitle">Incident Reporting and Response System</div>
              <div class="login-brand__restricted">
                <v-icon small color="#ffffff">mdi-lock-outline</v-icon>
                <span>Restricted Access</span>
              </div>
            </div>
          </div>

          <div class="login-form-panel">
            <div class="login-form-panel__top">
              <div class="login-form-panel__crest-wrap" style="display: flex; flex-direction: column; align-items: center;">
                <img :src="keralaForestLogo" alt="Kerala Forest Department logo" class="login-form-panel__crest">
                <span style="margin-top: 8px; font-size: 16px; letter-spacing: 1.2px; text-transform: uppercase; text-align: center; font-family: sofiaProBold;"><span style="color: #333333;">Kerala</span> <span style="color: #8b7d2a;">Forest</span> <span style="color: #333333;">Department</span></span>
              </div>
            </div>

            <div class="login-copy">
              <h2 class="login-title">Welcome Back</h2>
              <p class="login-subtitle" style="color: green; font-size: 15px;">
                Enter your username and password to access the conflict management portal.
              </p>
            </div>

            <div class="login-form-card">
              <v-form @submit.prevent="validateInput">
                <div class="login-field-wrap">
                  <v-text-field
                    v-model="emailId"
                    class="mainfont login-input"
                    color="#5aa34c"
                    prepend-inner-icon="mdi-account"
                    placeholder="Username"
                    outlined
                    dense
                    hide-details
                  />
                </div>

                <div class="login-field-wrap">
                  <v-text-field
                    v-model="password"
                    class="mainfont login-input input-group--focused"
                    color="#5aa34c"
                    prepend-inner-icon="mdi-lock-outline"
                    :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show3 ? 'text' : 'password'"
                    placeholder="Password"
                    outlined
                    dense
                    hide-details
                    @click:append="show3 = !show3"
                  />
                </div>

                <!-- <div class="login-field-wrap captcha-wrap">
                  <div class="captcha-img-box" v-html="captchaSvg" @click="getCaptcha"></div>
                  <v-btn icon color="#5aa34c" class="captcha-refresh-btn" @click="getCaptcha">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                  <v-text-field
                    v-model="captchaInput"
                    class="mainfont login-input captcha-input"
                    color="#5aa34c"
                    placeholder="Captcha Code"
                    outlined
                    dense
                    hide-details
                  />
                </div> -->

                <div class="login-meta">
                  <v-checkbox
                    v-model="rememberMe"
                    class="remember-check"
                    color="#5aa34c"
                    hide-details
                    label="Remember me"
                  />
                </div>

                <v-btn class="login-button no-uppercase mainfont" block dark @click="validateInput">
                  Login
                </v-btn>
              </v-form>
            </div>

            <div class="login-note">
              Authorised personnel only. All access attempts and case actions are monitored.
            </div>

            <div class="login-support">
              <span class="login-support__label">Developed &amp; Managed by</span>
              <div class="login-support__logo-wrap">
                <img :src="leopardTechLogo" alt="Leopard Tech Labs logo" class="login-support__logo">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="login-footer">
        <div class="login-footer__left">© 2026 Kerala Forest Department. All rights reserved.</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "../store";
import sarpaLogo from "../assets/sarpa-logo.png";
import wildwatchLogo from "../assets/wildwatch-logo.png";
import keralaForestLogo from "../assets/Logo_of_Kerala_Forest_Department.png";
import leopardTechLogo from "../assets/leopard-tech-labs-logo.png";

function rc4(key, str) {
  var s = [], j = 0, x, res = '';
  for (var i = 0; i < 256; i++) {
    s[i] = i;
  }
  for (i = 0; i < 256; i++) {
    j = (j + s[i] + key.charCodeAt(i % key.length)) % 256;
    x = s[i]; s[i] = s[j]; s[j] = x;
  }
  i = 0; j = 0;
  for (var y = 0; y < str.length; y++) {
    i = (i + 1) % 256;
    j = (j + s[i]) % 256;
    x = s[i]; s[i] = s[j]; s[j] = x;
    res += String.fromCharCode(str.charCodeAt(y) ^ s[(s[i] + s[j]) % 256]);
  }
  return res;
}

function encryptValue(value, secretKeyText) {
  try {
    const cipher = rc4(secretKeyText, value);
    const hex = Array.from(cipher).map(c => c.charCodeAt(0).toString(16).padStart(2, '0')).join('');
    return "enc:" + hex;
  } catch (e) {
    console.error("Encryption failed:", e);
    return value;
  }
}

export default {
  data() {
    return {
      sarpaLogo,
      wildwatchLogo,
      keralaForestLogo,
      leopardTechLogo,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      otp: null,
      phone: null,
      emailId: null,
      password: null,
      section: "hwc",
      rememberMe: true,
      show1: false,
      show2: true,
      show3: false,
      show4: false,
      captchaSvg: "",
      captchaToken: "",
      captchaInput: "",
    };
  },
  mounted() {
    this.phone = this.$route.query.phone;
    // this.getCaptcha();
  },
  methods: {
    /* getCaptcha() {
      axios({
        method: "GET",
        url: "/platform/captcha/",
      })
        .then((response) => {
          if (response.data.status) {
            this.captchaSvg = response.data.data;
            this.captchaToken = response.data.token;
            this.captchaInput = "";
          }
        })
        .catch((error) => {
          console.error("Failed to load captcha", error);
        });
    }, */
    validateInput() {
      if (!this.emailId) {
        this.msg = "Please Provide Username.";
        this.showSnackBar = true;
        return;
      }
      if (!this.password) {
        this.msg = "Please Provide Password.";
        this.showSnackBar = true;
        return;
      }
      /* if (!this.captchaInput) {
        this.msg = "Please Enter the Captcha code.";
        this.showSnackBar = true;
        return;
      } */
      this.login();
    },
    login() {
      let encryptedPassword = this.password;
      let encryptedUsername = this.emailId;
      try {
        encryptedPassword = encryptValue(this.password, "hwc_s3cur3St@t1cK3y!2025");
        encryptedUsername = encryptValue(this.emailId, "hwc_s3cur3St@t1cK3y!2025");
      } catch (e) {
        console.error("Encryption error, falling back:", e);
      }
      axios({
        method: "POST",
        url: "/platform/login/",
        data: {
          username: encryptedUsername,
          password: encryptedPassword,
          // captchaText: this.captchaInput,
          // captchaToken: this.captchaToken,
        },
      })
        .then((response) => {
          if (response.data.heartbeat) {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("userRole", response.data.data.type);
            if (
              response.data.data.division &&
              response.data.data.division.length > 0 &&
              response.data.data.division[0]
            ) {
              localStorage.setItem("division", response.data.data.division[0]);
            }
            localStorage.setItem("activeSection", this.section);
            localStorage.setItem("loginType", response.data.data.loginType);
            this.$store.commit("userData", response.data.userDetails);
            this.$store.commit("loginUser", response.data.data.token);
            this.$store.commit("userRole", response.data.data.type);
            this.$store.commit("mainRole", response.data.data.role);
            this.$store.commit("loginType", response.data.data.loginType);
            this.$store.commit("userName", response.data.data.username);
            localStorage.setItem("minister", response.data.data.minister || "no");
            this.$store.commit("minister", response.data.data.minister || "no");
            if (response.data.data.loginType == "MASTER") {
              if (response.data.data.minister == "yes") {
                this.$router.push("/minister/dashboard");
              } else {
                if (this.section === "sarpa") {
                  this.$router.push("/Sarpa/dashboard");
                } else {
                  this.$router.push("/admin/analyticspage");
                }
              }
            }
            else if (response.data.data.role == "official") this.$router.push("/officers");
            else if (response.data.data.role == "analyst" || response.data.data.type == "analyst" || response.data.data.loginType == "ANALYST") this.$router.push("/analyst/snakerescued");
            else if (response.data.data.type == "admin") {
              if (this.section === "sarpa") {
                this.$router.push("/Sarpa/dashboard");
              } else {
                this.$router.push("/admin/analyticspage");
              }
            }
            else if (response.data.data.type == "SEOC") {
              if (this.section === "sarpa") {
                this.$router.push("/Sarpa/dashboard");
              } else {
                this.$router.push("/admin/analyticspage");
              }
            }
            else if (response.data.data.type == "EmergencyUser") this.$router.push("/officers");
            else if (response.data.data.type == "RRT") this.$router.push("/officers");
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
            // this.getCaptcha();
          }
        })
        .catch((err) => {
          store.commit("appLoading", false);
          // this.getCaptcha();
          if (err.response && err.response.data && err.response.data.msg) {
            this.msg = err.response.data.msg;
            this.showSnackBar = true;
          } else {
            this.ServerError = true;
          }
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.login-shell {
  position: relative;
  min-height: 100vh;
  background:
    linear-gradient(rgba(28, 61, 34, 0.78), rgba(28, 61, 34, 0.78)),
    url("../assets/images/authentication/loginimage.png") center center / cover no-repeat;
  overflow: hidden;
}

.login-overlay {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 12% 55%, rgba(0, 0, 0, 0.22), transparent 22%),
    radial-gradient(circle at 88% 62%, rgba(0, 0, 0, 0.22), transparent 24%);
  pointer-events: none;
}

.login-content {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 14px 18px 8px;
}

.login-card-wrap {
  display: flex;
  justify-content: center;
}

.login-card {
  width: 100%;
  max-width: 1040px;
  display: grid;
  grid-template-columns: 1.02fr 0.98fr;
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(6, 27, 12, 0.3);
}

.login-brand {
  position: relative;
  background: linear-gradient(180deg, rgba(59, 98, 55, 0.94) 0%, rgba(82, 122, 65, 0.92) 100%);
  padding: 36px 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-brand__orb {
  position: absolute;
  top: -18px;
  right: -14px;
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.11);
}

.login-brand__inner {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 360px;
  text-align: center;
  color: #ffffff;
}

.login-brand__logos {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.login-brand__logo-box {
  width: 104px;
  height: 104px;
  padding: 12px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.96);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 14px 24px rgba(16, 45, 18, 0.16);
}

.login-brand__logo-box--wide {
  width: 104px;
}

.login-brand__logo {
  max-width: 100%;
  max-height: 72px;
  object-fit: contain;
}

.login-brand__logo--wildwatch {
  max-height: 62px;
}

.login-brand__title {
  margin: 0;
  font-family: sofiaProSemiBold;
  font-size: 28px;
  line-height: 1.1;
  letter-spacing: 0.03em;
}

.login-brand__subtitle {
  margin-top: 10px;
  font-family: poppinsregular;
  font-size: 14px;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.login-brand__restricted {
  margin-top: 14px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 13px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  font-family: sofiaProSemiBold;
  font-size: 11px;
  text-transform: uppercase;
}

.login-form-panel {
  background: #fffefc;
  padding: 24px 24px 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.login-form-panel__top {
  display: flex;
  justify-content: center;
  width: 100%;
}

.login-form-panel__crest-wrap {
  padding: 0;
}

.login-form-panel__crest {
  width: 72px;
  height: 72px;
  object-fit: contain;
}

.login-copy {
  width: 100%;
  max-width: 380px;
  margin: 12px auto 0;
  text-align: center;
}

.login-title {
  margin: 0;
  font-family: sofiaProSemiBold;
  font-size: 34px;
  line-height: 1.06;
  color: #2d3c28;
}

.login-subtitle {
  margin: 8px auto 0;
  max-width: 340px;
  font-family: poppinsregular;
  font-size: 14px;
  line-height: 1.55;
  color: #758571;
}

.login-form-card {
  width: 100%;
  max-width: 390px;
  margin: 18px auto 0;
  padding: 16px;
  border: 1px solid #e7efe2;
  border-radius: 22px;
  background: #fffefc;
  box-shadow: inset 0 0 0 1px rgba(237, 242, 233, 0.8);
}

.login-field-wrap + .login-field-wrap {
  margin-top: 12px;
}

.login-input ::v-deep .v-input__slot {
  min-height: 52px !important;
  border-radius: 16px !important;
  box-shadow: inset 0 0 0 1px #e2ebdc;
  padding: 0 10px !important;
}

.login-input ::v-deep input {
  font-family: poppinsregular;
  font-size: 14px;
}

.login-input ::v-deep .v-input__prepend-inner,
.login-input ::v-deep .v-input__append-inner {
  align-self: center !important;
  margin-top: 0 !important;
}

.login-input ::v-deep .v-input__prepend-inner .v-icon,
.login-input ::v-deep .v-input__append-inner .v-icon {
  font-size: 20px !important;
}

.login-meta {
  margin-top: 4px;
}

.remember-check {
  margin-top: 0;
  padding-top: 0;
}

.remember-check ::v-deep label {
  font-family: poppinsregular;
  font-size: 13px;
  color: #6a7b69 !important;
}

.remember-check ::v-deep .v-input--selection-controls__ripple {
  top: calc(50% - 16px) !important;
}

.login-button {
  margin-top: 8px;
  height: 46px !important;
  border-radius: 16px;
  background: linear-gradient(180deg, #789f4f 0%, #5e8940 100%) !important;
  font-family: sofiaProSemiBold;
  font-size: 16px;
  letter-spacing: 0.06em;
}

.login-note {
  max-width: 390px;
  margin: 14px auto 0;
  padding-top: 12px;
  border-top: 1px solid #e5ece0;
  text-align: center;
  font-family: poppinsregular;
  font-size: 11px;
  line-height: 1.45;
  color: #7b867b;
}

.login-support {
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-support__label {
  margin-bottom: 6px;
  font-family: poppinsregular;
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #728070;
}

.login-support__logo-wrap {
  padding: 0;
}

.login-support__logo {
  width: 118px;
  height: 34px;
  object-fit: contain;
}

.login-footer {
  margin-top: 8px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #f5f7f0;
  font-family: poppinsregular;
  font-size: 12px;
}

.snackbar-text {
  color: white;
}

@media (max-width: 1100px) {
  .login-card {
    max-width: 920px;
  }
}

@media (max-width: 900px) {
  .login-content {
    padding: 18px 12px 12px;
  }

  .login-card {
    grid-template-columns: 1fr;
  }

  .login-brand {
    padding: 26px 20px;
  }

  .login-form-panel__crest {
    width: 220px;
    height: 28px;
  }

  .login-title {
    font-size: 32px;
  }
}

@media (max-width: 700px) {
  .login-brand__logos {
    flex-direction: column;
  }

  .login-brand__logo-box,
  .login-brand__logo-box--wide {
    width: 112px;
    height: 112px;
  }

  .login-brand__title {
    font-size: 26px;
  }

  .login-title {
    font-size: 26px;
  }

  .login-form-panel {
    padding: 18px 14px 14px;
  }

  .login-form-panel__crest {
    width: 180px;
    height: 24px;
  }

  .login-form-card {
    padding: 14px;
  }

  .login-input ::v-deep .v-input__slot {
    min-height: 48px !important;
  }

  .login-support__logo {
    width: 104px;
    height: 30px;
  }

  .login-footer {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
}

.captcha-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.captcha-img-box {
  flex: 0 0 120px;
  height: 52px;
  background: #f4f7f2;
  border-radius: 16px;
  border: 1px solid #d2ded0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
}

.captcha-img-box ::v-deep svg {
  width: 100%;
  height: 100%;
}

.captcha-refresh-btn {
  flex: 0 0 auto;
}

.captcha-input {
  flex: 1 1 auto;
}
</style>
